import {
  currentReadRights,
  isLoggedIn,
  logout,
} from "@/store/useAuthentification";
import { setSnackBar } from "@/store/useNotificationSnackBar";
import { eTypeSnackBar } from "@/types/ui";
import {
  createRouter,
  createWebHashHistory,
  RouteLocationNormalized,
  RouteRecordRaw,
} from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "root",
    component: () => import("@/views/HomeView.vue"),
    meta: { authorize: [], title: "Accueil" },
  },
  {
    path: "/home",
    name: "home",
    component: () => import("@/views/HomeView.vue"),
    meta: {
      authorize: [],
      title: "Choix des buses - Régler votre pulvérisateur",
    },
  },
  {
    path: "/mentionslegales",
    name: "mentionslegales",
    component: () => import("@/views/MentionsView.vue"),
    meta: { authorize: [], title: "Choix des buses | Mentions légales" },
  },
  {
    path: "/about",
    name: "about",
    component: () => import("@/views/AboutView.vue"),
    meta: { authorize: [], title: "Choix des buses | En savoir plus" },
  },
  {
    path: "/pulverisation/plein",
    name: "pulveplein",
    component: () => import("@/views/PulvePlein.vue"),
    meta: { authorize: [], title: "Choix des buses | Pulvérisation en plein" },
  },
  {
    path: "/pulverisation/localisee",
    name: "pulvelocalisee",
    component: () => import("@/views/PulveLocalisee.vue"),
    meta: { authorize: [], title: "Choix des buses | Pulvérisation localisée" },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach(
  async (to: RouteLocationNormalized, from: RouteLocationNormalized, next) => {
    document.title = to.meta.title as string;
    const authorize = to.meta.authorize as string[];

    if (authorize == undefined || authorize.length === 0) {
      // Si aucune info,  c'est qu'il n'y a pas de restriction --> On continue!
      next();
    } else {
      if (!isLoggedIn) {
        logout();
        next({ path: "/login" });
      } else {
        // Check session et actualise le tocken
        //const activeSession = await refreshTokenUser();

        //if (!activeSession) {
        //   next({ path: "/login" });
        // } else {
        const userRight = currentReadRights.value.map((value) => value.code);
        const intersection = authorize.filter((x) => userRight.includes(x));
        if (intersection.length > 0 || authorize.includes("*")) {
          next();
        } else {
          setSnackBar("snack-notif.not-authorized", eTypeSnackBar.warning);
          next({ path: "/" });
        }
        // }
      }
    }
    next();
  },
);

export default router;
